<template>
    <div>
        <div class="layout-right bg mb16">
            <Form :label-width="110">
                <Row :gutter="24">
                    <Col span="8">
                        <Form-item label="保单号">
                            <Input v-model.trim="params.policyScrip" clearable placeholder="请输入保单号" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="保单状态">
                            <Select v-model="params.status" clearable>
                                <Option v-for="(item,index) in list" :value="item.value" :key="index">{{ item.label }}</Option>
                            </Select>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="险种">
                            <Input v-model.trim="params.insuranceName" clearable placeholder="请输入险种" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="保单创建时间">
                            <daterange @on-change="val=>{setDateRange(val,'createTime')}" placeholder="请选择创建时间" placement="bottom-end"></daterange>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="保障起期">
                            <DatePicker type="date" v-model="params.beginDate" placeholder="请选择" style="width: 100%" @on-change="val => params.beginDate = val"></DatePicker>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="保障止期">
                            <DatePicker type="date" v-model="params.endDate" placeholder="请选择" style="width: 100%" @on-change="val => params.endDate = val"></DatePicker>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="保障凭证号">
                            <Input v-model.trim="params.policyNo" clearable placeholder="请输入保障凭证号" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                </Row>
                <Row>
                    <Col span="24" class="right">
                        <Button type="primary" @click="tabChange">搜索</Button>
                        <Button type="primary" @click="exportToExcel('/specialEquipment/policy/export',params)">导出</Button>
                    </Col>
                </Row>
            </Form>
        </div>
        <div class="layout-right bg">
            <i-table :columns="columns" url="/specialEquipment/policy/list.json" :params="params" ref="table">
                <template slot-scope="{row}" slot="autoRenewal">
                    {{ row.autoRenewal?'是':'否' }}
                </template>
                <template slot-scope="{ row }" slot="action">
                    <Dropdown transfer>
                        <a href="javascript:void(0)">
                            管理
                            <Icon type="ios-arrow-down"></Icon>
                        </a>
                        <Dropdown-menu slot="list">
                            <Dropdown-item @click.native="toDetail(row)" style="text-align: center;">
                                <a>查看详情</a>
                            </Dropdown-item>
                            <Dropdown-item v-if="row.status=='2'" style="text-align: center;">
                                <a @click="downPolicy(row)">下载电子保单</a>
                            </Dropdown-item>
                            <Dropdown-item v-if="(row.status=='1' || row.status=='2')&&row.policyTimeType=='2' && !row.autoRenewal" style="text-align: center;">
                                <a @click="toRenew(row)">自动续费</a>
                            </Dropdown-item>
                            <!-- 工单要求隐藏自动续费操作 -->
                            <!-- <Dropdown-item v-if="(row.status=='1' || row.status=='2')&&row.policyTimeType=='2' && row.autoRenewal" style="text-align: center;">
                                <a @click="toCancelRenew(row)">取消自动续费</a>
                            </Dropdown-item> -->
                        </Dropdown-menu>
                    </Dropdown>
                    <!-- <a v-if="row.effectiveStatus=='REVIEWING'" class="ml5" @click="toRest(row)">批单</a> -->
                </template>
            </i-table>
        </div>
    </div>
</template>
<script>
    import ITable from '@/components/common/ITable'
    import daterange from '@/components/common/daterange'
    export default {
        name:'policyTPL',
        components:{ ITable,daterange },
        data () {
            return {
                loading: false,
                params: {},
                columns: [
                    {title:'保障凭证号',key:'policyNo',width: 260,fixed: 'left'},
                    {title:'保单号',key:'policyScrip',width: 260},
                    {title:'险种',key:'insuranceName',minWidth: 180,ellipsis: true,tooltip: true},
                    {title:'保费（元）',key:'amount',width: 120,align: 'right'},
                    {title:'保障起期',key:'beginDate',width: 120},
                    {title:'保障止期',key:'endDate',width: 120},
                    {title:'保单创建时间',key:'createTime',width: 180},
                    {title:'是否自动续费',slot:'autoRenewal',minWidth: 160},
                    {title:'状态',key:'statusName',width: 120},
                    {
                        title: '操作',
                        slot: 'action',
                        width: 90,
                        align: 'center',
                        fixed: 'right'
                    }
                ],
                list:[
                    {
                        value: '1',
                        label: '待生效'
                    },
                    {
                        value: '2',
                        label: '保障中'
                    },
                    {
                        value: '3',
                        label: '已过期'
                    }
                ]
            }
        },
        computed:{
        },
        created () {
            // this.getList()
        },
        methods:{
            // 自动续费
            toRenew(row){
                this.$Modal.confirm({
                    title: '提示',
                    content: '是否开启自动续费服务？',
                    onOk: () => {
                        this.$axios.post('/specialEquipment/policy/setAutoRenewal.json',{
                            policyNo: row.policyNo,
                            autoRenewal: true
                        }).then(res=>{
                            this.$Message.info('操作成功');
                            this.tabChange();
                        })
                    }
                });
            },
            // 取消自动续费
            toCancelRenew(row){
                this.$Modal.confirm({
                    title: '提示',
                    content: '是否取消自动续费服务？',
                    onOk: () => {
                        this.$axios.post('/specialEquipment/policy/setAutoRenewal.json',{
                            policyNo: row.policyNo,
                            autoRenewal: false
                        }).then(res=>{
                            this.$Message.info('操作成功');
                            this.tabChange();
                        })
                    }
                });
            },
            setDateRange (val,key) {
                this.params[key+"Begin"] = val[0];
                this.params[key+"End"] = val[1];
            },
            downPolicy(row){
                this.$axios.post('/specialEquipment/policy/download.json',{
                    policyNo: row.policyNo
                }).then(res=>{
                    const newPage = window.open(); // 打开一个不被拦截的空白窗口
                    newPage.location.href = res // 修改空白窗口的url
                })
            },
            tabChange(){
                this.$refs.table.getList()
            },
            toDetail(row){
                this.$router.push({
                    path:`/my/customizedTPL/policyDetail/${row.policyNo}`
                })
            }
        }
    }
</script>
<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedForklift/policy/index.vue